import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { ServicesProvider } from "../services/index.js";
import { GlobalStyles, createTheme } from "./config/index.js";
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const VKHRTekUIProvider = (t0)=>{
    const $ = c(12);
    let children;
    let services;
    let t1;
    if ($[0] !== t0) {
        const { services: t2, children: t3 } = t0, rest = _object_without_properties(t0, [
            "services",
            "children"
        ]);
        services = t2;
        children = t3;
        t1 = createTheme(rest);
        $[0] = t0;
        $[1] = children;
        $[2] = services;
        $[3] = t1;
    } else {
        children = $[1];
        services = $[2];
        t1 = $[3];
    }
    const theme = t1;
    let t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx(GlobalStyles, {});
        t3 = /*#__PURE__*/ jsx(CssBaseline, {});
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    let t4;
    if ($[6] !== children || $[7] !== services) {
        t4 = /*#__PURE__*/ jsx(ServicesProvider, {
            services: services,
            children: children
        });
        $[6] = children;
        $[7] = services;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4 || $[10] !== theme) {
        t5 = /*#__PURE__*/ jsxs(ThemeProvider, {
            theme: theme,
            children: [
                t2,
                t3,
                t4
            ]
        });
        $[9] = t4;
        $[10] = theme;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
export { VKHRTekUIProvider };
